import { render, staticRenderFns } from "./addWorkType.vue?vue&type=template&id=57785188"
import script from "./addWorkType.vue?vue&type=script&lang=js"
export * from "./addWorkType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports